import { takeLatest } from 'redux-saga/effects';
import createCrudService from '../../services/crudservice';
import {
  doCrudCall,
  SAVING_MSG,
  UPDATING_MSG,
  DELETING_MSG,
  LOADING_MSG,
  createRecordSuccess,
  updateRecordSuccess,
  deleteRecordSuccess
} from '../../utils/crudSagaHelper';

import {
  getEmployeeAwardListSuccess,
  getEmployeeAwardListFail,
  getEmployeeAwardDetailsSuccess,
  getEmployeeAwardDetailsFail,
  getEmployeeAwardDashboardSuccess,
  getEmployeeAwardDashboardFail
} from './employeeAwardState';

const crudService = createCrudService('api/v1/awards/employee-awards');

const redirectData = {
  route: '/console/awards',
  mode: 'list',
  recordId: 0
};

const modelName = 'Employee Nomination';
const modelId = 'ema_id';

function* getEmployeeAwardList(data) {
  yield doCrudCall(
    () => crudService.getList(data.payload),
    getEmployeeAwardListSuccess,
    getEmployeeAwardListFail,
    null,
    null,
    LOADING_MSG
  );
}

function* getEmployeeAwardDetails(data) {
  yield doCrudCall(
    () => crudService.getDetails(data.payload),
    getEmployeeAwardDetailsSuccess,
    getEmployeeAwardDetailsFail,
    null,
    null,
    LOADING_MSG
  );
}

function* doEmployeeAwardCreate(data) {
  yield doCrudCall(
    () => crudService.doCreate(data.payload),
    getEmployeeAwardDetailsSuccess,
    getEmployeeAwardDetailsFail,
    createRecordSuccess(modelName),
    { ...redirectData, mode: 'reload' },
    SAVING_MSG
  );
}

function* doEmployeeAwardUpdate(data) {
  yield doCrudCall(
    () => crudService.doUpdate(data.payload[modelId], data.payload),
    getEmployeeAwardDetailsSuccess,
    getEmployeeAwardDetailsFail,
    updateRecordSuccess(modelName),
    { ...redirectData, mode: 'reload' },
    UPDATING_MSG
  );
}

function* doEmployeeAwardDelete(data) {
  yield doCrudCall(
    () => crudService.doDelete(data.payload.recordId),
    getEmployeeAwardDetailsSuccess,
    getEmployeeAwardDetailsFail,
    deleteRecordSuccess(modelName),
    { ...redirectData, mode: data.payload.mode },
    DELETING_MSG
  );
}

function* getEmployeeAwardDashboard() {
  yield doCrudCall(
    () => crudService.doGetRequest('dashboard'),
    getEmployeeAwardDashboardSuccess,
    getEmployeeAwardDashboardFail,
    null,
    null,
    LOADING_MSG
  );
}

function* employeeAwardSaga() {
  yield takeLatest('employeeAward/getEmployeeAwardList', getEmployeeAwardList);
  yield takeLatest('employeeAward/getEmployeeAwardDetails', getEmployeeAwardDetails);
  yield takeLatest('employeeAward/doEmployeeAwardCreate', doEmployeeAwardCreate);
  yield takeLatest('employeeAward/doEmployeeAwardUpdate', doEmployeeAwardUpdate);
  yield takeLatest('employeeAward/doEmployeeAwardDelete', doEmployeeAwardDelete);
  yield takeLatest('employeeAward/getEmployeeAwardDashboard',getEmployeeAwardDashboard);
}

export default employeeAwardSaga;